import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import reframe from 'reframe.js';

import Facts from '../facts';

const Article = ({ article, facts }) => {
  const { title, content } = article;
  let image = null;
  let video = null;
  let showImage = true;
  if ('customerStory' in article) {
    if (article.customerStory.heroVideo) {
      showImage = false;
      video = article.customerStory.heroVideo;
    } else if (article.customerStory.heroImage) {
      image = article.customerStory.heroImage;
    }
  } else {
    image = article.featuredImage;
  }
  if (
    'postType' in article &&
    article.postType.nodes.length &&
    article.postType.nodes.map(({ categoryId }) => categoryId).includes(16)
  ) {
    showImage = false;
  }

  useEffect(() => {
    reframe('.block iframe');
  }, []);

  return (
    <article className="post-single__article">
      <h1>{title}</h1>
      {video && parse(video)}
      {image && showImage && (
        <img
          className="post-single__image"
          src={image.sourceUrl}
          alt={image.altText}
          role="presentation"
          fetchpriority="high"
        />
      )}

      {parse(content, {
        replace(domNode) {
          if (
            domNode.name === 'a' &&
            domNode.attribs.href &&
            domNode.attribs.href.charAt(0) !== '/' &&
            domNode.attribs.href.charAt(0) !== '#' &&
            domNode.attribs.href.indexOf('kabbage.com') === -1
          ) {
            return React.cloneElement(
              domToReact([domNode]),
              { target: '_blank' },
              domToReact(domNode.children)
            );
          }
          return true;
        },
      })}

      {facts && <Facts facts={facts} />}
    </article>
  );
};

Article.propTypes = {
  article: PropTypes.shape({
    postType: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          categoryId: PropTypes.number,
        })
      ),
    }),
    content: PropTypes.string,
    title: PropTypes.string,
    customerStory: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      heroImage: PropTypes.object,
      heroVideo: PropTypes.string,
    }),
    // eslint-disable-next-line react/forbid-prop-types
    featuredImage: PropTypes.object,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  facts: PropTypes.object,
};

Article.defaultProps = {
  article: {
    postType: {
      nodes: [],
    },
    content: '',
    title: '',
    customerStory: null,
    featuredImage: null,
  },
  facts: null,
};

export default Article;
